import { combineReducers } from 'redux';

import {
  SET_ADDRESS_FIELDS,
  ADDRESS_FIRSTNAME,
  ADDRESS_LASTNAME,
  ADDRESS_PHONE_COUNTRY,
  ADDRESS_PHONE,
  ADDRESS_EMAIL,
  ADDRESS_IS_JURIDIC,
  ADDRESS_COMPANY,
  ADDRESS_COMPANY_INN,
  ADDRESS_COMPANY_KPP,
  ADDRESS_COMPANY_OGRN,
  ADDRESS_COMPANY_CHIEF_NAME,
  ADDRESS_COMPANY_CONTACT_NAME,
  ADDRESS_COMPANY_JOB_TITLE,
  ADDRESS_COMPANY_SCOPE,
  ADDRESS_COMPANY_LEGAL_ADDR,
  ADDRESS_COMPANY_POST_ADDR,
  REQUEST_COUNTRIES,
  RECEIVE_COUNTRIES,
} from './actions';

const initialState = {
  fields: {
    [ADDRESS_FIRSTNAME]: '',
    [ADDRESS_LASTNAME]: '',
    [ADDRESS_PHONE_COUNTRY]: 'RU',
    [ADDRESS_PHONE]: '',
    [ADDRESS_EMAIL]: '',
    [ADDRESS_IS_JURIDIC]: false,

    [ADDRESS_COMPANY]: '',
    [ADDRESS_COMPANY_INN]: '',
    [ADDRESS_COMPANY_KPP]: '',
    [ADDRESS_COMPANY_OGRN]: '',
    [ADDRESS_COMPANY_CHIEF_NAME]: '',
    [ADDRESS_COMPANY_CONTACT_NAME]: '',
    [ADDRESS_COMPANY_JOB_TITLE]: '',
    [ADDRESS_COMPANY_SCOPE]: '',
    [ADDRESS_COMPANY_LEGAL_ADDR]: '',
    [ADDRESS_COMPANY_POST_ADDR]: '',

    hasErrors: false,
  }
}

function addressFields(state = initialState, action = 0) {
  switch (action.type) {
    case SET_ADDRESS_FIELDS:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}

const countriesList = (state = [], action = 0) => {
  switch (action.type) {
    case RECEIVE_COUNTRIES:
      return action.data;
    default:
      return state;
  }
};

const isFetching = (state = false, action = {}) => {
  switch (action.type) {
    case REQUEST_COUNTRIES:
      return true;
    case RECEIVE_COUNTRIES:
      return false;
    default:
      return state;
  }
};

export const getAddressFields = (state) => state.addressFields;

export const addressField = (state = [], fieldName = '') => state.addressFields[fieldName];

export const isCountriesFetching = (state) => state.isFetching;

export const getCountries = (state) => state.countriesList;

export const getIsJuridic = (state) => state.addressFields[ADDRESS_IS_JURIDIC];

export const getFormErrors = (state) => {
  const fields = state.addressFields;
  const errors = {};

  if (!fields[ADDRESS_FIRSTNAME]) errors[ADDRESS_FIRSTNAME] = 'обязательно для заполнения';
  if (!fields[ADDRESS_LASTNAME]) errors[ADDRESS_LASTNAME] = 'обязательно для заполнения';
  if (!fields[ADDRESS_PHONE]) errors[ADDRESS_PHONE] = 'обязательно для заполнения';

  if (fields[ADDRESS_IS_JURIDIC]) {
    if (!fields[ADDRESS_COMPANY]) errors[ADDRESS_COMPANY] = 'обязательно для заполнения';
    if (!fields[ADDRESS_COMPANY_JOB_TITLE]) errors[ADDRESS_COMPANY_JOB_TITLE] = 'обязательно для заполнения';
  }

  return errors;
};

export const hasFormErrors = (state) => {
  const errors = getFormErrors(state);
  return Object.keys(errors).length > 0;
};

const address = combineReducers({
  addressFields,
  countriesList,
  isFetching
});

export default address;